import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import { navigate } from 'libs/router';

import ActionButton from 'components/buttons/action-button/ActionButton';
import Form from 'components/form/Form';
import FormField from 'components/form/form-field/FormField';
import Input from 'components/inputs/input/Input';

import { requestActivationEmail } from '../reducers/activationEmail';
import { danger, success } from 'redux-store/reducers/common-reducer';

import { isEmail, isRequired } from 'utils/validators';
import { t } from 'utils/language';

import '../common/access-form.scss';
import '../common/access-actions.scss';

type Props = {
  dispatch: any
};

type State = {
  email: string
};

class RequestActivationEmailForm extends Component<Props, State> {
  state = {
    email: ''
  };

  handleSubmit = (event) => {
    const { dispatch } = this.props;
    const { email } = this.state;

    event.preventDefault();
    dispatch(requestActivationEmail({ email }))
      .then(() => {
        navigate.to('/login');
        dispatch(success(t('resend_activation_email_message')));
      })
      .catch((error) => {
        const errorCode = get(error, 'response.data.code');
        if (errorCode === 'request.invalid') {
          dispatch(danger(t('user_account_not_found', { email })));
        } else {
          dispatch(danger(error.message));
        }
      });
  };

  handleTextInput = (event) => {
    this.setState({
      email: event.target.value
    });
  };

  render() {
    return (
      <Form
        onSubmit={this.handleSubmit}
        className="access-form"
        data={{ qa: 'access-form' }}
      >
        <FormField
          label={t('signup_email')}
          validators={[
            isRequired(this.state.email),
            isEmail(this.state.email)
          ]}
        >
          <Input
            onChange={this.handleTextInput}
            name="email"
            value={this.state.email}
          />
        </FormField>
        <div className="access-actions">
          <ActionButton
            color="tertiary"
            link="/login"
            data-qa="access-form__button"
          >
            {t('action_button_cancel')}
          </ActionButton>
          <ActionButton
            type="submit"
            data-qa="access-form__button"
          >
            {t('password_reset_send_email_button')}
          </ActionButton>
        </div>
      </Form>
    );
  }
}

export default connect()(RequestActivationEmailForm);
